"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../searchEventCreators/factory");
var utils_1 = require("../../utils");
var searchinteractionHander = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.SearchInteraction || context.isHandled) {
        return;
    }
    if (event.eventName === analytics_layer_1.SearchInteractionEventNames.SearchLoad &&
        ((0, analytics_layer_1.queueEventNameCount)(analytics_layer_1.SearchInteractionEventNames.SearchLoad) > 1 ||
            (0, analytics_layer_1.queueContainsEventType)(analytics_layer_1.EventTypes.ScreenLoad))) {
        (0, analytics_layer_1.resetEventQueue)();
        (0, utils_1.resetEventQueue)();
    }
    // main:
    var _a = (0, factory_1.getCreator)(event.eventName)(event), mainEventData = _a[0], _b = _a[1], linkEventData = _b === void 0 ? null : _b;
    (0, utils_1.pushEvent)(mainEventData);
    // link:
    if (linkEventData) {
        (0, utils_1.pushEvent)(linkEventData);
    }
    context.isHandled = true;
};
exports.default = searchinteractionHander;
